import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import stl from "./OpenMenuSelection.module.css";
import { CDN_LINK } from "@globalConfig";
import CheckBox from "../AsideSubMenu/components/CheckBoxGroup/CheckBox/CheckBox";
function OpenMenuSelection(_ref) {
  var options = _ref.options,
    onChange = _ref.onChange,
    title = _ref.title,
    isOpen = _ref.isOpen,
    isCampaign = _ref.isCampaign,
    filter = _ref.filter,
    tempSelectedOptions = _ref.tempSelectedOptions,
    selectedOptions = _ref.selectedOptions;
  // Initialize with isOpen prop to ensure SSR/CSR consistency and prevent CLS
  var _useState = useState(isOpen),
    isOpenFilter = _useState[0],
    setIsOpenFilter = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "filter-open-menu-condition",
    className: [stl.container, !isOpenFilter ? stl.closedStyle : undefined, isCampaign ? stl.isCampaign : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    id: "filter-open-menu-condition-toggle",
    className: stl.title,
    onClick: function onClick() {
      isCampaign ? !isOpen && setIsOpenFilter(!isOpenFilter) : setIsOpenFilter(!isOpenFilter);
    }
  }, /*#__PURE__*/React.createElement("strong", null, title), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrAcc.svg",
    alt: "arrow",
    width: "12px",
    height: "7px"
  })), isOpenFilter && /*#__PURE__*/React.createElement("div", {
    id: "filter-open-menu-condition-options"
  }, options === null || options === void 0 ? void 0 : options.map(function (option, i) {
    var isChecked = tempSelectedOptions !== null && tempSelectedOptions !== void 0 && tempSelectedOptions.find(function (item) {
      return item.id === option.id && (item === null || item === void 0 ? void 0 : item.filterField) === "condition_id";
    }) || selectedOptions !== null && selectedOptions !== void 0 && selectedOptions.find(function (item) {
      return item.id === option.id && (item === null || item === void 0 ? void 0 : item.filterField) === "condition_id";
    }) ? true : false;
    return /*#__PURE__*/React.createElement(CheckBox, {
      disabled: false,
      fieldName: filter.facetName,
      key: option.id,
      option: option,
      label: option.name,
      value: option.id,
      onChange: onChange,
      count: option.count,
      checked: isChecked,
      filter: filter
    });
  }))));
}
export default OpenMenuSelection;